import { IResponse } from '@/utils/interfaces';
import { ICities } from '@/utils/interfaces/Cities';
import { IStates } from '@/utils/interfaces/States';

import { apiClient } from '../apiClients';
import { Endpoints } from '../../network';
import {
  AddressPayload,
  CountryType,
} from '../../utils/interfaces/Manage-Addresses';

export interface ICerateAddress {
  set_default: number;
  user_id: number;
  address: string;
  name: string;
  country_id: string;
  city_id: string;
  state_id: string;
  postal_code: string;
  phone: string;
  country_code?: string;
  iso2?: string;
}

export const getAddresses = async () => {
  const response = await apiClient.get(Endpoints.getAllAddresses);

  return response?.data?.data;
};

export const updateAddress = async (data: AddressPayload, cartId?: number) => {
  const params: {
    data: AddressPayload;
    card_id?: number;
  } = { data };

  if (cartId) params.card_id = cartId;

  const response = await apiClient.post(`${Endpoints.updateAddress}`, {
    ...params.data,
    card_id: params.card_id,
  });

  return response?.data?.data;
};

export const createCity = async (name: string, state_id: number) => {
  const response = await apiClient.post(`${Endpoints.createCity}`, {
    name,
    state_id,
  });

  return response?.data?.data;
};

export const createAddressService = async (
  data: ICerateAddress,
  cartId?: number,
) => {
  const params: {
    data: ICerateAddress;
    card_id?: number;
  } = { data };
  params.data.set_default = data.set_default ? 1 : 0;

  if (cartId) params.card_id = cartId;
  const response = await apiClient.post(`${Endpoints.createAddress}`, {
    ...params.data,
    card_id: params.card_id,
  });

  return response?.data;
};

export const updateAddressRadioButtonSelect = async (data: {
  id: number;
  set_default: number;
}) => {
  const response = await apiClient.post(`${Endpoints.updateAddress}`, data);

  return response?.data?.data;
};

export const deleteAddress = async (id: number) => {
  const response = await apiClient.delete(`${Endpoints.deleteAddress}/${id}`);

  return response?.data?.data;
};

export const updateDefaultAddress = async (id: number) => {
  const response = await apiClient.post(`${Endpoints.updateDefaultAddress}`, {
    id,
  });

  return response?.data?.data;
};

export const getAllCountries = async (): Promise<IResponse<CountryType[]>> => {
  const response = await apiClient.get(Endpoints.getAllCountries);

  return response?.data;
};
export const getStates = async (id: number): Promise<IResponse<IStates[]>> => {
  const response = await apiClient.get(`${Endpoints.getStates}/${id}`);

  return response?.data;
};
export const getCities = async (id: number): Promise<IResponse<ICities[]>> => {
  const response = await apiClient.get(`${Endpoints.getCities}/${id}`);

  return response?.data;
};
